import ClipLoader from 'react-spinners/ClipLoader';
import { ReactComponent as HelpIcon } from '../../assets/img/modal/help.svg';
import { ReactComponent as ImpactIcon } from '../../assets/img/modal/impact.svg';
import { ReactComponent as LocationIcon } from '../../assets/img/modal/location.svg';
import { ReactComponent as SourceIcon } from '../../assets/img/modal/source.svg';
import { ReactComponent as AlarmIcon } from '../../assets/img/modal/alarm.svg';
import { ReactComponent as WarningIcon } from '../../assets/img/modal/warnings.svg';
import { ReactComponent as SevereWarningIcon } from '../../assets/img/modal/severe_warnings.svg';
import { ParsedWarningContent } from '../../services/warnings/severeWarnings';
import "./Warnings.css";

const WarningContent = ({ warning, isLoading, type }:
    { warning: ParsedWarningContent | null, isLoading: boolean, type: string, }
) => {

    if (isLoading || !warning) {
        return (
            <div className={'load-content'}>
                <ClipLoader
                    color={'#313638'}
                    loading={true}
                    size={35}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
        );
    }

    const Icon = type === "normal_warning" ? SevereWarningIcon : WarningIcon;

    return (
        <>
            <div className='warning-modal-infobox'>
                <div className='warning-modal-infobox-basic'>
                    <div className=''>
                        <Icon />
                    </div>

                    <div className=''>
                        <p className='infobox-type'>Alert</p>
                        <h2 className='infobox-title'>{warning.title}</h2>
                        {
                            warning.date.length > 0 && (
                                <div className='infobox-date'>
                                    <p className='infobox-date-key'>Date:</p>
                                    <p className='infobox-date-value'>{warning.date}</p>
                                </div>
                            )
                        }
                    </div>
                </div>
                {
                    warning.issuer && (
                        <div className='warning-modal-infobox-source'>
                            <div className='warning-modal-infobox-source-inline'>
                                <SourceIcon />
                                <p>{warning.issuer}</p>
                            </div>
                        </div>
                    )
                }
            </div>

            <div className='warning-modal-details'>
                <h2 className='warning-modal-details-heading'>More Details</h2>
                {
                    warning.areas && warning.areas.length > 0 && (
                        <div className='warning-modal-details-content'>
                            <div className='warning-modal-details-content-title'>
                                <p>
                                    Affected area:
                                </p>
                            </div>
                            <p className='warning-modal-details-content-value'>
                                {
                                    warning.areas
                                }
                            </p>
                        </div>
                    )
                }
                {
                    warning.what && warning.what.length > 0 && (
                        <div className='warning-modal-details-content'>
                            <div className='warning-modal-details-content-title'>
                                <HelpIcon />
                                <p>What:</p>
                            </div>
                            <p className='warning-modal-details-content-value'>
                                {warning.what}
                            </p>

                        </div>
                    )
                }
                {
                    warning.where && warning.where.length > 0 && (
                        <div className='warning-modal-details-content'>
                            <div className='warning-modal-details-content-title'>
                                <LocationIcon />
                                <p>Where:</p>
                            </div>
                            <p className='warning-modal-details-content-value'>
                                <span>
                                    {" " + warning.where}
                                </span>
                            </p>
                        </div>
                    )
                }
                {
                    warning.when && (
                        <div className='warning-modal-details-content'>
                            <div className='warning-modal-details-content-title'>
                                <AlarmIcon />
                                <p>When:</p>
                            </div>
                            <p className='warning-modal-details-content-value'>
                                {warning.when}
                            </p>
                        </div>
                    )
                }
                {
                    warning.impact && warning.impact.length > 0 && (
                        <div className='warning-modal-details-content'>
                            <div className='warning-modal-details-content-title'>
                                <ImpactIcon />
                                <p>Impact:</p>
                            </div>
                            <p className='warning-modal-details-content-value'>
                                {warning.impact}
                            </p>
                        </div>
                    )
                }
                {
                    warning.actions && warning.actions.length > 0 && (
                        <div className='warning-modal-precautions-container'>
                            <p className='warning-modal-precautions-title'>
                                Precautionary/Preparedness actions:
                            </p>
                            <p className='warning-modal-precautions-value'>
                                {warning.actions}
                            </p>
                        </div>
                    )
                }
            </div>
        </>
    );
}

export default WarningContent;